<template>
  <div @mouseleave="menuleave">
    <el-menu
      ref="menu"
      :default-active="activeIndex"
      class="menus"
      mode="horizontal"
      @select="handleSelect"
      text-color="#22222E"
      active-text-color="#22222E"
    >
      <div v-for="(item, i) in menus" :key="i">
        <template v-if="!item.hidden && item.meta.title">
          <template v-if="item.flatNav">
            <el-menu-item
              :index="i.toString()"
              :key="String(i)"
              @mouseenter.native="menuHover(i)"
            >
              {{ item.meta.title }}
              <i
                :class="[
                  JSON.stringify(flatData) !== '{}'
                    ? 'el-icon-arrow-up'
                    : 'el-icon-arrow-down',
                ]"
              ></i>
            </el-menu-item>
          </template>

          <template v-else>
            <el-menu-item
              v-if="!item.showChildren && !item.open"
              :index="i.toString()"
              :key="String(i)"
              @mouseenter.native="menuleave"
            >
              {{ item.meta.title }}
            </el-menu-item>

            <el-menu-item
              v-else-if="item.open"
              :index="i.toString()"
              :key="String(i)"
              @mouseenter.native="menuleave"
            >
              <div target="_blank" href="item.open" style="display: block">
                {{ item.meta.title }}
              </div>
            </el-menu-item>

            <el-submenu
              v-else
              :index="i.toString()"
              :popper-append-to-body="false"
            >
              <template slot="title">{{ item.meta.title }}</template>
              <el-menu-item
                :index="i + '-' + index"
                v-for="(el, index) in item.children"
                :key="index"
              >
                <span v-if="!el.open">{{ el.meta.title }}</span>
                <a
                  target="_blank"
                  v-else-if="el.open"
                  :href="el.open"
                  style="font-size: 20px; display: block"
                >
                  {{ el.meta.title }}
                </a>
              </el-menu-item>
            </el-submenu>
          </template>
        </template>
      </div>
    </el-menu>
  </div>
</template>

<script>
import flatNav from "../layout/styleMenus";
import { mapGetters } from "vuex";

export default {
  name: "Router",
  components: {
    flatNav,
  },
  computed: {
    ...mapGetters(["menus", "activeIndex", "userInfo"]),
    key() {
      return this.$route.path;
    },
  },
  created() {
    console.log("this.menus999", this.menus);
    debugger;
    this.jumpRefresh();
  },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      flatData: {},
      flatShow: false,
    };
  },
  methods: {
    jumpRefresh() {
      document.body.addEventListener(
        "click",
        function (event) {
          var target = event.target || event.srcElement; // 兼容处理
          if (target.nodeName.toLocaleLowerCase() === "a") {
            // 判断是否匹配目标元素
            setTimeout(() => location.reload(), 100);
          }
        }.bind(this)
      );
    },
    menuHover(e) {
      console.log(e);
      if (this.menus[e] && this.menus[e].flatNav) {
        this.flatData = this.menus[e];
      }
      if (Object.keys(this.flatData).length > 0) {
        this.flatShow = true;
        this.$store.commit("app/SET_TOP_BG", true);
      }
    },
    menuleave() {
      this.flatShow = false;
      this.flatData = {};
      this.$store.commit("app/SET_TOP_BG", false);
    },
    handleSelect(e) {
      // console.log(e)
      // this.flatShow = !this.flatShow
      //
      // if (JSON.stringify(this.flatData) !== '{}') {
      //     this.flatData = {}
      // } else {
      //     // 扁平菜单数据
      //     if (this.menus[e] && this.menus[e].flatNav) {
      //         this.flatData = this.menus[e]
      //     }
      // }
      let row = "";
      if (e.indexOf("-") > -1) {
        //子菜单点击
        const list = e.split("-");
        let obj = list.reduce((pre, cur) => {
          if (pre.children) {
            pre = pre.children[cur];
          } else {
            pre = this.menus[cur];
          }
          return pre;
        }, {});
        row = JSON.parse(JSON.stringify(obj));
      } else {
        row = JSON.parse(JSON.stringify(this.menus[e]));
      }
      console.log("row", row.mCode);
      this.$pvuv.getEvent(row.mCode);
      if (row.target && row.target === true) {
        if (!row.open) {
          let blank = this.$router.resolve(row.path);
          window.open(blank.href, "_blank");
          window.location.reload();
        } else {
          if (row.name == "大数据中心") {
            console.log("userInfo", this.userInfo);
            if (Object.keys(this.userInfo).length == 0) {
              if (process.env.NODE_ENV === "testing") {
                window.open("https://cs-sj.hbgyl.com.cn/sjfw/", "_blank");
              } else {
                window.open("https://sj.hbgyl.com.cn/sjfw/", "_blank");
              }
              // this.$message({
              //   message: '该系统未登录',
              //   type: 'warning'
              // });
              // setTimeout(() => {
              //   if(process.env.NODE_ENV === 'testing'){
              //     window.open('https://cs-sj.hbgyl.com.cn/sjfw/','_blank')
              //   }else{
              //     window.open('https://sj.hbgyl.com.cn/sjfw/','_blank')
              //   }

              // },3000)
            } else {
              window.open(row.path, "_blank");
              // if(process.env.NODE_ENV === 'testing'){
              //   if(this.userInfo.customizeValues == 1 || this.userInfo.customizeValues == 3){
              //     window.open(row.path,'_blank')
              //   }else{
              //     this.$message({
              //       message: '当前账号无权限，请升级为企业用户！',
              //       type: 'warning'
              //     });
              //   }
              // }else{
              //   if(this.userInfo.customizeValues == 1 || this.userInfo.customizeValues == 3){
              //     window.open(row.path,'_blank')
              //   }else{
              //     this.$message({
              //       message: '当前账号无权限，请升级为企业用户！',
              //       type: 'warning'
              //     });
              //   }
              // }
            }
          } else {
            window.open(row.path, "_blank");
          }
          //  window.open(row.path,'_blank')
        }
      } else {
        this.$router.push(row.path);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/ .el-menu.el-menu--horizontal > div {
  display: inline-block;
}

/deep/ .el-menu--horizontal .el-menu-item.is-active {
  color: #22222e;
  border-bottom: 2px #386ce8 solid !important;
  background-color: transparent;
}

.menus {
  background-color: transparent;
}

.menus /deep/ .el-menu-item,
.menus /deep/ .el-submenu__title {
  font-size: 18px;
  padding: 0;
  color: #22222e;
  margin-right: 30px;
  height: 68px;
  line-height: 68px;
}

.second_nav .menus /deep/ .el-menu-item,
.second_nav .menus /deep/ .el-submenu__title {
  height: auto;
  line-height: 26px;
  padding-bottom: 29px;
}

.menus > div:last-child /deep/ .el-menu-item {
  margin-right: 0;
}

.menus /deep/ .el-menu-item:hover {
  background-color: transparent;
}

.menus .el-menu-item:hover {
  background-color: transparent;
}

.menus /deep/ .el-submenu__title:hover {
  background-color: transparent;
}

.menus /deep/ .el-submenu__icon-arrow {
  right: -20px;
}

.menus /deep/ .el-submenu__title i {
  color: #22222e;
  font-size: 16px;
}

.menus /deep/ .el-menu-item:focus {
  background-color: transparent;
}

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: 0px;
}

/deep/ .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
  color: #22222e !important;
}

/**
    菜单鼠标经过样式
   */
.el-menu-item:hover {
  background-color: transparent !important;
}

/deep/ .el-submenu > div:hover {
  background-color: transparent !important;
}

.el-menu-item:hover {
  opacity: 0.75;
}

.el-menu--horizontal .el-menu--popup .el-menu-item {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}

.el-menu--horizontal .el-menu-item.is-active {
  background-color: transparent !important;
}
</style>
<style scoped lang="less">
@media (min-width: 320px) and (max-width: 750px) {
  .menus /deep/ .el-menu-item,
  .menus /deep/ .el-submenu__title {
    font-size: 14px;
    padding: 0;
    color: #22222e;
    margin-right: 15px;
    height: 40px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top_menv/index.vue